import { Controller, useForm } from "react-hook-form";
import _ from "@lodash";
import { useTranslation } from 'react-i18next';
import React from "react";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import BackIcon from "@mui/icons-material/Backspace";
import { FormControl, InputLabel, Select, IconButton, Card, MenuItem } from "@mui/material";



function YouthOpportunitiesFilter() {
    const { t } = useTranslation("YouthOpportunitiesPage");  

  return (
    <>

      <Card variant="outlined" className="m-24 mb-0">
        <div className="flex content-between justify-start m-24">
          <div className="w-1/3 mt-16 mr-16">
            <Box sx={{ minWidth: 120 }} >
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                {t("STATUS")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select status"
                  
                >
                  <MenuItem value={"1"}>All</MenuItem>
                  <MenuItem value={"2"}>New</MenuItem>
                  <MenuItem value={"3"}>Applied</MenuItem>
                  <MenuItem value={"4"}>Selected</MenuItem>
                  <MenuItem value={"5"}>Not Selected</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>

          <div className="mt-20">
            {" "}
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <SearchIcon />
            </IconButton>
          </div>
          <div className="mt-20  mr-1">
            {" "}
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <BackIcon />
            </IconButton>
          </div>
        </div>
      </Card>

    </>
  );
}

export default YouthOpportunitiesFilter;
